import type {
  CountrySettingCreateApiData,
  CountrySettingCreateApiResponses,
  CountrySettingDeleteApiData,
  CountrySettingDeleteApiResponses,
  CountrySettingGetApiData,
  CountrySettingGetApiResponses,
  CountrySettingListApiData,
  CountrySettingListApiResponses,
  CountrySettingPatchApiData,
  CountrySettingPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getCountrySettingUrls = {
  getPaginatedCountrySettings: dataEndpoint<CountrySettingListApiData, CountrySettingListApiResponses>({
    getUrl: (queryParams) => apiUrl('country-settings/', queryParams)
  }),
  getCountrySetting: dataEndpoint<CountrySettingGetApiData, CountrySettingGetApiResponses>({
    getUrl: ({ countrySettingId }) => apiUrl(`country-settings/${countrySettingId}/`)
  }),
  postCountrySetting: responseEndpoint<CountrySettingCreateApiData, CountrySettingCreateApiResponses>({
    getUrl: () => apiUrl('country-settings/'),
    getBody: (data) => data
  }),
  patchCountrySetting: responseEndpoint<CountrySettingPatchApiData, CountrySettingPatchApiResponses>({
    getUrl: ({ countrySettingId }) => apiUrl(`country-settings/${countrySettingId}/`),
    getBody: (data) => data
  }),
  deleteCountrySetting: dataEndpoint<CountrySettingDeleteApiData, CountrySettingDeleteApiResponses>({
    getUrl: ({ countrySettingId }) => apiUrl(`country-settings/${countrySettingId}/`)
  })
};
